import { render, staticRenderFns } from "./ChromeExtensionCard.vue?vue&type=template&id=1ea14db0&scoped=true&"
import script from "./ChromeExtensionCard.vue?vue&type=script&lang=js&"
export * from "./ChromeExtensionCard.vue?vue&type=script&lang=js&"
import style0 from "./ChromeExtensionCard.vue?vue&type=style&index=0&id=1ea14db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea14db0",
  null
  
)

export default component.exports